import PropTypes from 'prop-types';
import React, { useContext } from 'react';
import { useSelector } from 'react-redux';
import { VIP_EXCLUSIVE_TAG } from '../../../../config/constants/images';
import {
  BASED_ON_SHARING,
  PERCT_OFF,
  QUANTITY,
  SAVE,
  SELECT_QUANTITY,
  SOLD_OUT,
  BESTSELLER,
} from '../../../../config/text/text';
import { isLightPage } from '../../../../helpers/browser';
import { getSelectValues, isOdd } from '../../../../helpers/checkout';
import { formatCurrency } from '../../../../helpers/currency';
import {
  getProductPurchaseCap,
  getDealPurchaseCap,
  isExist,
} from '../../../../helpers/deals';
import ThemeContext from '../../../../providers/ThemeProvider';
import CustomNativeSelect from '../../../_generic/custom-native-select/CustomNativeSelect';
import DealInfoBox from '../info-box/DealInfoBox';

// eslint-disable-next-line complexity
const DealChooseYourOptionsItem = ({
  deal = {},
  item = null,
  index = -1,
  quantity = 0,
  onQuantityChange = () => {},
  remainingQuantity = null,
  isClaim = false,
}) => {
  const theme = useContext(ThemeContext);
  const isInvalidPricePerPersonDeal = deal.pricePerPerson && isOdd(quantity);
  const [isVipUser] = useSelector((state) => [
    state?.user?.userprofile?.vipUser,
  ]);

  if (!item) return null;

  if (isLightPage() && item.soldOut) return null;

  let max = getProductPurchaseCap(deal, index);
  if (isExist(remainingQuantity))
    max = getDealPurchaseCap(max, remainingQuantity, quantity);

  const quantities = getSelectValues(0, max);

  const showDiscount = (item.displayDiscount && item.discount > 0) || false;
  const discount = deal.display?.discountAmount
    ? `${SAVE} ${formatCurrency(deal.currency, item.discount, false, false)}`
    : `${item.discountPercentage}${PERCT_OFF}`;
  const isVipExclusiveDeal = item?.vipExclusive;
  const isBestSellerClaim = item?.bestSellerClaim;
  const isMarketingCreditDeal = isVipUser && deal?.display?.vipDiscountAllowed;
  const finalPrice = isMarketingCreditDeal ? item.vipPrice : item.price;

  return (
    <>
      <div className="deal__info-box">
        <DealInfoBox show={isInvalidPricePerPersonDeal}>
          {BASED_ON_SHARING}
        </DealInfoBox>
      </div>
      <div className="cyo-row">
        <div className="cyo-row__title">
          <div>{item.friendlyName || item.title}</div>
          {isVipExclusiveDeal && (
            // VIP LOGO when a deal is an VIP exclusive
            <img
              alt="VIP Exclusive Tag"
              src={VIP_EXCLUSIVE_TAG[process.env.NEXT_PUBLIC_BRAND]}
              width="100"
            />
          )}
        </div>
        {!isClaim && (
          <div className="cyo-row__numbers cyo-row__data-item">
            <div className="cyo-row__prices">
              <div className="cyo-row__price">
                <div>
                  {formatCurrency(deal.currency, finalPrice, false, false)}
                </div>
              </div>
              {showDiscount && (
                <div className="cyo-row__original-price">
                  {formatCurrency(
                    deal.currency,
                    item.originalPrice,
                    false,
                    false,
                  )}
                </div>
              )}
            </div>
            {showDiscount && (
              <div className="cyo-row__discount">{discount}</div>
            )}

            {isBestSellerClaim && (
              <div className="green-bestseller">{BESTSELLER}</div>
            )}
          </div>
        )}

        <div className="cyo-row__quantity cyo-row__data-item">
          {item.soldOut && <p className="cyo-row__sold-out">{SOLD_OUT}</p>}

          {!item.soldOut && (
            <>
              <label className="cyo-row__quantity-label">{QUANTITY}</label>
              <CustomNativeSelect
                ariaLabel={SELECT_QUANTITY}
                className="quantity-select-input primary"
                onChange={(event) => onQuantityChange(event, index)}
                testId="cyo-select"
                value={quantity}
              >
                {quantities.map((value) => {
                  return (
                    <option key={value} value={value}>
                      {value}
                    </option>
                  );
                })}
              </CustomNativeSelect>
            </>
          )}
        </div>
      </div>
      <style jsx>{`
        .deal__info-box {
          margin: 0px 20px;
        }
        .cyo-row {
          min-height: 50px;
          margin: 20px;
          border-bottom: 1px solid ${theme.colors.primary};
          justify-content: space-between;
          display: flex;
          flex-direction: row;
          padding-bottom: 8px;
          flex-basis: 50%;
        }
        .cyo-row__title {
          margin-right: 12px;
          flex-grow: 1;
        }
        .cyo-row__data-item {
          text-align: center;
        }
        .cyo-row__numbers {
          margin-right: 12px;
          flex-shrink: 0;
          flex-basis: 30%;
        }
        .cyo-row__prices {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 5px;
        }
        .cyo-row__price {
          font-size: 18px;
          font-weight: bold;
          color: ${theme.colors.primary};
          line-height: 1em;
          margin-right: 8px;
          flex-grow: 1;
          display: flex;
          flex-direction: column;
          height: 100%;
          justify-content: space-between;
        }
        .cyo-row__original-price {
          position: relative;
        }
        .cyo-row__original-price:after {
          position: absolute;
          content: '';
          top: 50%;
          left: -4px;
          width: calc(100% + 8px);
          border-top: 1px solid #7f7f7f;
          transform: rotate(-11deg);
        }
        .cyo-row__discount {
          font-weight: bold;
          background-color: #70e4fc;
          width: 100%;
          padding: 0 8px;
        }
        .cyo-row__sold-out {
          margin: 0;
          color: #7f7f7f;
        }
        .cyo-row__quantity {
          width: 56px;
        }
        .cyo-row__quantity-label {
          display: block;
          line-height: 1em;
          margin-bottom: 4px;
          color: ${theme.colors.primary};
          width: 100%;
        }
        .green-bestseller {
          color: white;
          background: ${theme.commoncolors.assure};
          font-weight: 600;
          padding: 6px 10px;
          white-space: break-spaces;
          font-size: 13px;
          border-radius: 18px 18px 0px 0px;
          margin-bottom: -8px;
          margin-top: 6px;
        }
        @media (max-width: ${theme.breakpoints.smDown}) {
          .cyo-row :last-child .green-bestseller {
            margin-bottom: -20px;
          }
          .cyo-row:last-child {
            border-bottom: none;
            padding-bottom: 0;
          }
          .cyo-row__numbers {
            display: flex;
            flex-direction: column;
          }
          .green-bestseller {
            margin-top: auto;
            align-self: flex-end;
          }
        }
      `}</style>
    </>
  );
};

DealChooseYourOptionsItem.propTypes = {
  deal: PropTypes.object,
  index: PropTypes.number,
  isClaim: PropTypes.bool,
  item: PropTypes.object,
  onQuantityChange: PropTypes.func,
  quantity: PropTypes.number,
  remainingQuantity: PropTypes.number,
};

export default DealChooseYourOptionsItem;
